<template>
  <div class="horizontal-card-style1">
    <div class="card-header">
      <div class="card-header-left">
        <p class="card-header-title">{{title}}</p>
        <p class="card-header-dataDesc">{{dataDesc}}</p>
        <template v-if="dataUpdateTime">
          <i class="separator"></i>
          <p class="card-header-dataUpdateTime">更新于{{dataUpdateTime}}</p>
        </template>
      </div>
      <div class="card-header-right" v-if="btnText">
        <el-button v-if="btnText" type="text" size="mini" @click="handleBtnClick">{{btnText}}</el-button>
      </div>
    </div>
    <div class="card-body">
      <div class="card-body-inner">
        <div class="primary-data-list">
          <template v-for="(data) in primaryDataList">
            <div :class="{
              'data-card': true,
              primary: true,
              alignItemsCenter: !ratioConfig.showRatio || primaryDataList.every(item => !item.ratioList || (Array.isArray(item.ratioList) && !item.ratioList.length))
            }" :style="data.width ? {width: `${data.width}`} : {}" :key="data.label">
              <p class="data-label">
                <QS-clamp-lines tip-effect="dark" :lines="2" :text="data.label || ''" style="height: 44px" />
                <el-tooltip v-if="data.tooltip" effect="dark" placement="top" style="margin-left: 4px">
                  <div slot="content" v-html="data.tooltip"></div>
                  <i class="QS-icon-question-outline"></i>
                </el-tooltip>
              </p>
              <p :class="{
                'data-value-wrapper': true,
                'clickable': !!data.clickCallback
              }" @click="handleDataValueClick(data.clickCallback)">
                <el-tooltip v-if="data.valueTooltip" class="item" effect="dark" :content="data.valueTooltip" placement="top">
                  <span class="data-value">{{data.value}}</span>
                </el-tooltip>
                <span v-else class="data-value">{{data.value}}</span>
                <span class="data-unit">{{data.unit}}</span>
              </p>
              <div class="data-change-situation-list" v-if="ratioConfig.showRatio && Array.isArray(data.ratioList) && data.ratioList.length">
                <p class="data-change-situation" v-for="(item, index) in data.ratioList" :key="index">
                  <span class="situation-label">{{item.name}}</span>
                  <i :class="{
                    'situation-icon': true,
                    increase: item.value > 0,
                    decrease: item.value < 0
                  }"></i>
                  <span :class="{
                    'situation-value': true,
                    increase: item.value > 0,
                    decrease: item.value < 0
                  }">{{item.value === null || typeof item.value === 'undefined' ? '--' : (item.value * 100).toFixed(2).replace('-', '') + '%'}}</span>
                </p>
              </div>
            </div>
          </template>
        </div>
        <div class="secondary-data-list">
          <template v-for="(data) in secondaryDataList">
            <div :class="{
              'data-card': true,
              secondary: true,
              alignItemsCenter: !ratioConfig.showRatio || secondaryDataList.every(item => !item.ratioList || (Array.isArray(item.ratioList) && item.ratioList.length <= 1))
            }" :style="data.width ? {width: `${data.width}`} : {}" :key="data.label">
              <p class="data-label">
                <QS-clamp-lines tip-effect="dark" :lines="2" :text="data.label || ''" style="height: 44px" />
                <el-tooltip v-if="data.tooltip" effect="dark" :content="data.tooltip || ''" placement="top" style="margin-left: 4px">
                  <i class="QS-icon-question-outline"></i>
                </el-tooltip>
              </p>
              <p :class="{
                'data-value-wrapper': true,
                'clickable': !!data.clickCallback
              }" @click="handleDataValueClick(data.clickCallback)">
                <el-tooltip v-if="data.valueTooltip" class="item" effect="dark" :content="data.valueTooltip" placement="top">
                  <span class="data-value">{{data.value}}</span>
                </el-tooltip>
                <span v-else class="data-value">{{data.value}}</span>
                <span class="data-unit">{{data.unit}}</span>
              </p>
              <div class="data-change-situation-list" v-if="ratioConfig.showRatio && Array.isArray(data.ratioList) && data.ratioList.length">
                <p class="data-change-situation" v-for="(item, index) in data.ratioList" :key="index">
                  <span class="situation-label">{{item.name}}</span>
                  <i :class="{
                    'situation-icon': true,
                    increase: item.value > 0,
                    decrease: item.value < 0
                  }"></i>
                  <span :class="{
                    'situation-value': true,
                    increase: item.value > 0,
                    decrease: item.value < 0
                  }">{{item.value === null || typeof item.value === 'undefined' ? '--' : (item.value * 100).toFixed(2).replace('-', '') + '%'}}</span>
                </p>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  inject: ['ratioConfig'],
  props: {
    // 标题
    title: {
      type: String,
      default: '',
    },
    // 数据描述
    dataDesc: {
      type: String,
      default: '',
    },
    // 数据更新时间
    dataUpdateTime: {
      type: String,
      default: '',
    },
    // 按钮文本
    btnText: {
      type: String,
      default: '',
    },
    // 主要数据列表
    primaryDataList: {
      type: Array,
      default: () => [],
    },
    // 次要数据列表
    secondaryDataList: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleBtnClick() {
      this.$emit('btnClick')
    },
    handleDataValueClick(callback) {
      typeof callback === 'function' && callback()
    },
  },
}
</script>
<style lang="scss" scoped>
.horizontal-card-style1 {
  border-radius: 2px;
  overflow: hidden;
  .card-header {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 38px;
    padding: 8px 12px;
    background: #F8F8FA;
    &::before {
      position: absolute;
      top: 50%;
      left: 0;
      margin-top: -9px;
      content: '';
      width: 3px;
      height: 18px;
      background: #0256FF;
      border-radius: 10px;
    }
    .card-header-left {
      display: flex;
      align-items: center;
      .card-header-title {
        font-size: 14px;
        font-weight: 600;
        line-height: 22px;
        color: #3D3D3D;
      }
      .card-header-dataDesc {
        margin-left: 10px;
        font-size: 12px;
        font-weight: normal;
        line-height: 22px;
        color: #767676;
      }
      .separator {
        width: 1px;
        height: 10px;
        margin: 0 6px;
        flex: none;
        background: #767676;
      }
      .card-header-dataUpdateTime {
        font-size: 12px;
        font-weight: normal;
        line-height: 22px;
        color: #767676;
      }
    }
  }
  .card-body {
    display: flex;
    width: 100%;
    .card-body-inner {
       display: flex;
       width: 100%;
       height: 182px;
       overflow: hidden;
       .primary-data-list {
          display: flex;
          flex: none;
          min-width: 167px;
          background: #FFFFFF;
          border-left: 1px solid #ECEEF4;
          border-bottom: 1px solid #ECEEF4;
       }
       .secondary-data-list {
          display: flex;
          flex: 1;
          background: #F9FBFD;
          border: 1px solid #ECEEF4;
       }
    }
    .data-card {
      box-sizing: border-box;
      &.primary {
        width: 167px;
        height: 182px;
        padding: 0 24px 0 24px;
        flex: none;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        flex-direction: column;
        &:nth-child(n+2) {
          padding-left: 0;
        }
        .data-label {
          margin-bottom: 8px;
        }
        & + .secondary::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 1px;
          height: 100%;
          background: #ECEEF4;
          box-sizing: border-box;
        }
      }
      &.secondary {
        position: relative;
        height: 182px;
        padding: 24px 24px 0 24px;
        flex: 1;
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        &:nth-child(n+2) {
          padding-left: 0;
        }
        .data-label {
          margin-bottom: 8px;
        }
      }
      &.alignItemsCenter {
        justify-content: center;
        padding-top: 0;
      }
      .data-label {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        margin: 0px;
        font-size: 16px;
        font-weight: normal;
        color: #3D3D3D;
        ::v-deep .QS-icon-question-outline {
          align-self: flex-start;
          position: relative;
          top: 2px;
          color: #C0C4CC;
        }
      }
      .data-value-wrapper {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-end;
        margin: 0px;
        font-size: 24px;
        font-weight: 600;
        line-height: 24px;
        color: #3D3D3D;
        &.clickable {
          cursor: pointer;
        }
        .data-unit {
          position: relative;
          top: -2px;
          margin-left: 4px;
          font-size: 14px;
          font-weight: normal;
          line-height: 14px;
          color: #3D3D3D;
        }
      }
      .data-change-situation-list {
        margin: 7px 0 0 0;
        .data-change-situation {
          margin: 0;
          display: flex;
          align-items: center;
          &:not(:last-child) {
            margin: 0 0 4px 0;
          }
          .situation-label {
            flex: none;
            font-size: 12px;
            font-weight: normal;
            line-height: 22px;
            color: #767676;
          }
          .situation-icon {
            flex: none;
            margin: 0 2px 0 4px;
            &.increase {
              width: 10px;
              height: 7px;
              background: url('../../../../assets/img/ratio_up.png') 0 0 no-repeat;
              background-size: 100%;
            }
            &.decrease {
              width: 10px;
              height: 7px;
              background: url('../../../../assets/img/ratio_down.png') 0 0 no-repeat;
              background-size: 100%;
            }
          }
          .situation-value {
            &.increase {
              font-size: 12px;
              font-weight: normal;
              line-height: 14px;
              color: #0FC570;
            }
            &.decrease {
              font-size: 12px;
              font-weight: normal;
              line-height: 14px;
              color: #EA0000;
            }
          }
        }
      }
    }
  }
}
</style>
